import React from 'react';
const MarketPage = (props) => {
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M2.13281 2.5C2.13281 2.22386 2.35667 2 2.63281 2H13.6328C13.909 2 14.1328 2.22386 14.1328 2.5V13.5C14.1328 13.7761 13.909 14 13.6328 14H2.63281C2.35667 14 2.13281 13.7761 2.13281 13.5V2.5Z", stroke: "#3F465C" }),
        React.createElement("path", { d: "M14.1328 6.20581L2.13281 6.20581", stroke: "#3F465C", "stroke-linecap": "round" }),
        React.createElement("circle", { cx: "4.23281", cy: "4.10269", r: "0.6", fill: "#3F465C" }),
        React.createElement("circle", { cx: "6.43203", cy: "4.10269", r: "0.6", fill: "#3F465C" }),
        React.createElement("circle", { cx: "8.6332", cy: "4.10269", r: "0.6", fill: "#3F465C" })));
};
export default MarketPage;
